module.exports = __webpack_public_path__ + "static/media/team4.e779dead.png";